/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Observable } from 'rxjs';
import { BaseApi } from './BaseApi';

export class UniversalTrackerApi extends BaseApi {
  endPoint: string = '/api/admin/universal-trackers';

  public statusUpdate(data: any): Observable<any> {
    const _routeParams: any = {};
    const _postBody: any = {
      data: data
    };
    return this._post(this.endPoint + '/status/update', _routeParams, _postBody);
  }

  public findByInitiativeId(initiativeId: any): Observable<any> {
    const _routeParams: any = {
      initiativeId: initiativeId
    };
    return this._get(this.endPoint + '/initiativeId/:initiativeId', _routeParams);
  }

  public findByUniversalTrackerGroup(universalTrackerGroupId: any): Observable<any> {
    const _routeParams: any = {
      universalTrackerGroupId: universalTrackerGroupId
    };
    return this._get(this.endPoint + '/universalTrackerGroupId/:universalTrackerGroupId', _routeParams);
  }

  public updateAlternatives(id: String, data: any): Observable<any> {
    const _routeParams: any = {};
    const _postBody: any = {
      data: data
    };
    return this._patch(this.endPoint + '/' + id + '/alternatives', _routeParams, _postBody);
  }

  public downloadImportSheet(oktaToken: string): void {
    const url = this._generateURL(`${this.endPoint}/download-import-sheet?token=${oktaToken}`);
    window.open(url, '_blank');
  }

}
